/**
 * Q2 Caliper service. Used for integrating with Q2 service.
 */
import {Injectable} from '@angular/core';
import {PasswordPolicy} from "../model/models";
import {NGXLogger} from "ngx-logger";
import {CaliperApiControllerService} from "skyhopper-api";
import {Observable, BehaviorSubject} from "rxjs";
import { delay, map, retryWhen} from "rxjs/operators";
import { DELAY_BETWEEN_API_RETRIES, PASSWORD_POLICY_API_RETRIES } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class Q2caliperService {
  private _deactivatePasswordPolicy: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  get deactivatePasswordPolicy(): Observable<boolean> {
    return this._deactivatePasswordPolicy.asObservable();
  }

  constructor(private caliperService: CaliperApiControllerService,
              private logger: NGXLogger) {
  }

  /**
   *  Get password policy
   */
  async getPasswordPolicy(brandName: string): Promise<PasswordPolicy> {
    let attempt = 0;
    return new Promise((resolve, reject) => {
      this.caliperService.getPasswordPolicy1(brandName).pipe(
        retryWhen(errors => errors.pipe(
          delay(DELAY_BETWEEN_API_RETRIES),
          map(error => {
            if (attempt++ === PASSWORD_POLICY_API_RETRIES) {
              this._deactivatePasswordPolicy.next(true);
              throw error;
            }
            return error;
          })
        ))
      ).subscribe((response: any) => {
        if (!response.success) throw new Error();

          let passwordPolicy: PasswordPolicy = new PasswordPolicy(
            Number.parseInt(response.data?.MaxPasswordLength || "20", 10),
            Number.parseInt(response.data?.MinPasswordLength || "3", 10),
            response.data?.NumbersRequired === 1,
            response.data?.UpperCaseRequired === 1,
            response.data?.LowerCaseRequired === 1,
            response.data?.SpecialCharRequired === 1,
            response.data?.LimitRepeating === 1,
            response.data?.LimitAdjacent === 1,
            response.data?.ExcludeCharList || "")
          resolve(passwordPolicy);
        },
        error => {
          this.logger.debug(error);
          reject(error);
        });
    });
  }

  /**
   * Is the username provided valid. Returns false if it is already taken.
   * @param username Username to check
   */
  isUsernameValid(username: string): Observable<boolean> {
    return this.caliperService.checkForExistingUsername(username);
  }
}
